import { RideStationPanelMode } from "@ryde/shared";
import { blueGreyMui, greyMui } from "@ryde/theme";

export const getPassengerContactCellColor = (isGreyed: boolean): string =>
  isGreyed ? greyMui._500 : blueGreyMui._800;

export const isGridPanelPassengerDraggable = ({
  isLocked,
  mode,
  isUpdateRidePermission,
}: {
  isLocked: boolean;
  mode: RideStationPanelMode;
  isUpdateRidePermission: boolean;
}): boolean =>
  !isLocked &&
  mode === RideStationPanelMode.GRID_PANEL &&
  isUpdateRidePermission;

export const getPassengerShiftControlState = ({
  isEditBookingPermission,
  bookingIdToUse,
  displayShiftTime,
}: {
  isEditBookingPermission: boolean;
  bookingIdToUse: number | undefined;
  displayShiftTime: TDateISO | undefined;
}): { isClickable: boolean; isReadOnly: boolean } => {
  const isClickable = Boolean(isEditBookingPermission && bookingIdToUse);

  return {
    isClickable,
    isReadOnly: Boolean(displayShiftTime) && !isClickable,
  };
};
